import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
} from "@angular/core";
import { EventService } from "../event-service/event.service";

@Directive({
  selector: "[abSetFocusOn]",
})
export class SetFocusOnDirective implements AfterViewInit, OnDestroy {
  @Input("abSetFocusOn") public setFocusOn: string;
  public setFocusSub: any;

  constructor(
    private elementRef: ElementRef,
    private eventService: EventService,
  ) {}

  public ngAfterViewInit() {
    const elem = this.elementRef.nativeElement;

    this.setFocusSub = this.eventService.subscribe("setFocusOn", (id: any) => {
      if (id !== this.setFocusOn) {
        return;
      }

      elem.focus();

      if (elem.type === "text") {
        return elem.setSelectionRange(elem.value.length, elem.value.length);
      }
    });
  }

  public ngOnDestroy() {
    this.setFocusSub.unsubscribe();
  }
}
